import React from 'react';

import Button from '../../../Buttons/Button/Button';
import { ReactComponent as XIcon } from '../../../../assets/icons/XIcon.svg';

import classes from './FiltersChips.module.scss';

const Chip = ({ label, onDelete }) => (
  <div className={classes['applied-filters__filter']}>
    <span>{label || 'Filtro no identificado'}</span>
    <XIcon onClick={onDelete} />
  </div>
);

const FiltersChips = ({
  filterOptions,
  filterValues,
  filterOptionsGrouped,
  filterGroupedValues,
  cleanFiltersHander,
  changeFilterGroupedValues
}) => {
  const filterGroupedValuesFiltered = Object.entries(filterGroupedValues)
    .reduce(
      (prev, [filterKey, filterValue]) =>
        prev.concat({
          filterValue,
          label: filterOptionsGrouped.find(({ key }) => key === filterKey)?.options?.find(({ key }) => key === filterValue)?.label,
          onDelete: () => changeFilterGroupedValues(filterKey, 'all')
        }),
      []
    )
    .filter(({ filterValue }) => filterValue !== 'all');

  const showCleanFilters = filterValues.length > 0 || filterGroupedValuesFiltered.length > 0;

  return (
    <div className={classes['applied-filters']}>
      <div className={classes['applied-filters__header']}>
        <span className={`medium-16 ${classes['applied-filters__label']}`}>Se está filtrando por:</span>
        {showCleanFilters && (
          <Button custom='quaternary' onClick={cleanFiltersHander}>
            Limpiar filtros
          </Button>
        )}
      </div>
      <div className={`medium-16 ${classes['applied-filters__filters']}`}>
        {filterValues.map((filterValue, index) => (
          <Chip
            key={index}
            label={filterOptions.find(({ key }) => key === filterValue)?.label}
            onDelete={() => cleanFiltersHander(filterValue)}
          />
        ))}
        {filterGroupedValuesFiltered.map(({ label, onDelete }, index) => (
          <Chip key={index} label={label} onDelete={onDelete} />
        ))}
      </div>
    </div>
  );
};

export default FiltersChips;
